import { render, staticRenderFns } from "./ManteBazarRedes.vue?vue&type=template&id=403db980&"
import script from "./ManteBazarRedes.vue?vue&type=script&lang=js&"
export * from "./ManteBazarRedes.vue?vue&type=script&lang=js&"
import style0 from "./ManteBazarRedes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports